<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="subFranchises"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-sub-franchise") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'subFranchises'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-sub-franchise
      :modelDialog="subFranchiseDialog"
      @close="subFranchiseDialog = false"
    ></add-edit-sub-franchise>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditSubFranchise from "./admin/AddEditSubFranchise.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "SubFranchiseAdmin",
  components: { AddEditSubFranchise, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      subFranchiseDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      subFranchises: (state) => state.subFranchises.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.subFranchises.editedId
    }),
    pageCount() {
      return Math.ceil(this.subFranchises.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "subFranchises");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "subFranchises");
    },
    openDialog() {
      this.$store.commit("subFranchises/setEditedId", -1);
      this.$store.commit("subFranchises/setEditedItem", Object.assign({}, {}));
      this.subFranchiseDialog = true;
    },
    editItem(item) {
      this.$store.commit("subFranchises/setEditedId", item.id);
      this.$store.commit(
        "subFranchises/setEditedItem",
        Object.assign({}, item)
      );
      this.subFranchiseDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.sub-franchise"))) {
        this.$store
          .dispatch("subFranchises/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.sub-franchise-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "subFranchises");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.sub-franchise-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
